import { useState } from 'react';

import { Switch } from '@/components/ui/switch';

import { useRepresentative, type IRepresentative } from '../model';

const SignatoryAction = ({ id: representativeId, ...representative }: IRepresentative) => {
  const [isLoading, setIsLoading] = useState(false);

  const { submit, currentPolicyRole } = useRepresentative();

  const onChange = async (signatory: boolean) => {
    setIsLoading(true);

    try {
      await submit?.edit(representativeId, { ...representative, signatory });
    } finally {
      setIsLoading(false);
    }
  };

  if (currentPolicyRole?.update)
    return (
      <Switch
        onCheckedChange={onChange}
        checked={Boolean(representative.signatory)}
        disabled={isLoading || representative.suggestType === 'remove'}
      />
    );

  return <Switch checked={Boolean(representative.signatory)} disabled />;
};

export default SignatoryAction;
